export function focusElementById(id?: string): void {
  if (!id) return
  const element = document.getElementById(id)
  if (!element) return
  setTimeout(() => {
    element.focus()
  }, 100)
}
